import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet } from "../utils/api_service";
const initialState = {
  leaveType: [],
  leaveSummary: [],
  leaveApply: [],
  leaveForAuthorityPerson: [],
  leaveBalanceBySalesTeam: [],
  leaveSummaryBySalesTeam: [],
  leaveBalanceInfo: {},
};
let URL1 = endpoints.leaveSummary;
let URL = endpoints.leaveType;
let leaveApplyURL = endpoints.leaveApply;

const leaveTypeSlice = createSlice({
  name: "leaveType",
  initialState,
  reducers: {
    leaveTypeSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        leaveType: row,
      };
    },
    leaveSummarySuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        leaveSummary: row,
      };
    },

    leaveApplySuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        leaveApply: row,
      };
    },

    leaveForAuthorityPersonSuccess: (
      state = cloneDeep(initialState),
      action
    ) => {
      const { row } = action.payload;
      return {
        ...state,
        leaveForAuthorityPerson: row,
      };
    },

    leaveBalanceBySalesTeamSuccess: (
      state = cloneDeep(initialState),
      action
    ) => {
      const { row } = action.payload;
      return {
        ...state,
        leaveBalanceBySalesTeam: row,
      };
    },

    leaveSummaryBySalesTeamSuccess: (
      state = cloneDeep(initialState),
      action
    ) => {
      const { row } = action.payload;
      return {
        ...state,
        leaveSummaryBySalesTeam: row,
      };
    },

    leaveBalanceInfoSuccess: (
      state = cloneDeep(initialState),
      action
    ) => {
      const { row } = action.payload;
      return {
        ...state,
        leaveBalanceInfo: row,
      };
    },

    resetState: (state = cloneDeep(initialState), action) => {
      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export const {
  leaveTypeSuccess,
  leaveSummarySuccess,
  leaveApplySuccess,
  leaveForAuthorityPersonSuccess,
  leaveBalanceBySalesTeamSuccess,
  leaveSummaryBySalesTeamSuccess,
  leaveBalanceInfoSuccess,
  resetState,
} = leaveTypeSlice.actions;

export default leaveTypeSlice.reducer;

export const getLeaveType = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL,
    }).then(({ data, success }) => {
      if (success) {
        const { content } = data.data;
        const row = content.map((leaveTypeObject, index) => {
          let leaveTypeData = {
            index: index + 1,
            id: leaveTypeObject.id === null ? "" : leaveTypeObject.id,
            name: leaveTypeObject.name === null ? "" : leaveTypeObject.name,

            leaveSummaryName:
              leaveTypeObject.leaveSummary != null &&
                leaveTypeObject.leaveSummary.name != null
                ? ""
                : leaveTypeObject.leaveSummary.name,
            shortName:
              leaveTypeObject.shortName === null
                ? ""
                : leaveTypeObject.shortName,
            isActive:
              leaveTypeObject.isActive === null ? "" : leaveTypeObject.isActive,
            extra1:
              leaveTypeObject.extra1 === null ? "" : leaveTypeObject.extra1,
            leaveSummary:
              leaveTypeObject.leaveSummary === null
                ? ""
                : leaveTypeObject.leaveSummary,
            remark:
              leaveTypeObject.remark === null ? "" : leaveTypeObject.remark,
            company:
              leaveTypeObject.company === null ? "" : leaveTypeObject.company,
          };
          return leaveTypeData;
        });
        dispatch(leaveTypeSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getLeaveSummary = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL1 + "/get-active-list",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((leaveTypeObject, index) => {
          let leaveTypeData = {
            index: index + 1,
            id: leaveTypeObject.id === null ? "" : leaveTypeObject.id,
            name: leaveTypeObject.name === null ? "" : leaveTypeObject.name,
            leaveSummaryName:
              leaveTypeObject.name === null ? "" : leaveTypeObject.name,

            shortName:
              leaveTypeObject.shortName === null
                ? ""
                : leaveTypeObject.shortName,
            isActive:
              leaveTypeObject.isActive === null ? "" : leaveTypeObject.isActive,
            extra1:
              leaveTypeObject.extra1 === null ? "" : leaveTypeObject.extra1,
          };
          return leaveTypeData;
        });
        dispatch(leaveSummarySuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const setLeaveType =
  ({ row }) =>
    async (dispatch) => {
      dispatch(leaveTypeSuccess({ row }));
    };

export const getApprovalCount = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: leaveApplyURL + "/get-approval-count",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.leaveApplyList.map((leaveTypeObject, index) => {
          let claimDataNew = {
            index: index + 1,
            id: leaveTypeObject.id === null ? "" : leaveTypeObject.id,
            salesTeamId:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.id !== null
                ? leaveTypeObject.salesTeam.id
                : "",
            salesTeamName:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.name !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType.prefix !== null
                ? leaveTypeObject.salesTeam.name +
                " (" +
                leaveTypeObject.salesTeam.stockStakeHolderType.prefix +
                ")"
                : "",
            salesTeamStockHolderTypeId:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType.id !== null
                ? leaveTypeObject.salesTeam.stockStakeHolderType.id
                : "",
            salesTeamStockHolderTypeName:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType.name !== null
                ? leaveTypeObject.salesTeam.stockStakeHolderType.name
                : "",
            salesTeamStockHolderTypePrefix:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType.prefix !== null
                ? leaveTypeObject.salesTeam.stockStakeHolderType.prefix
                : "",

            leaveTypeId:
              leaveTypeObject.leaveType !== null &&
                leaveTypeObject.leaveType.id !== null
                ? leaveTypeObject.leaveType.id
                : "",
            leaveTypeName:
              leaveTypeObject.leaveType !== null &&
                leaveTypeObject.leaveType.name !== null
                ? leaveTypeObject.leaveType.name
                : "",
            authoritySalesPersonId:
              leaveTypeObject.authoritySalesPersonId === null
                ? ""
                : leaveTypeObject.authoritySalesPersonId,

            authoritySalesPersonTypeId:
              leaveTypeObject.authoritySalesPersonTypeId === null
                ? ""
                : leaveTypeObject.authoritySalesPersonTypeId,
            leaveReason:
              leaveTypeObject.leaveReason === null
                ? ""
                : leaveTypeObject.leaveReason,
            fromDate:
              leaveTypeObject.fromDate === null ? "" : leaveTypeObject.fromDate,
            toDate:
              leaveTypeObject.toDate === null ? "" : leaveTypeObject.toDate,
            noOfDays:
              leaveTypeObject.noOfDays === null ? "" : leaveTypeObject.noOfDays,
            description:
              leaveTypeObject.description === null
                ? ""
                : leaveTypeObject.description,
            attachFile:
              leaveTypeObject.attachFile === null
                ? ""
                : leaveTypeObject.attachFile,
            status:
              leaveTypeObject.status === null ? "" : leaveTypeObject.status,
            isActive:
              leaveTypeObject.isActive === null ? "" : leaveTypeObject.isActive,
            leaveCancelRemark:
              leaveTypeObject.leaveCancelRemark === null
                ? ""
                : leaveTypeObject.leaveCancelRemark,
            extra1:
              leaveTypeObject.extra1 === null ? "" : leaveTypeObject.extra1,
            statusForTable:
              leaveTypeObject.status === null
                ? ""
                : leaveTypeObject.status == 0
                  ? "Pending"
                  : leaveTypeObject.status == 1
                    ? "Cancelled"
                    : leaveTypeObject.status == 2
                      ? "Approved"
                      : leaveTypeObject.status == 3
                        ? "Rejected"
                        : "",
          };
          return claimDataNew;
        });

        dispatch(leaveApplySuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getLeaveSearch =
  ({ monthYear }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url: leaveApplyURL + "/by-login-person?monthYear=" + monthYear,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((leaveTypeObject, index) => {
              let claimData = {
                index: index + 1,
                id: leaveTypeObject.id === null ? "" : leaveTypeObject.id,
                salesTeamId:
                  leaveTypeObject.salesTeam !== null &&
                    leaveTypeObject.salesTeam.id !== null
                    ? leaveTypeObject.salesTeam.id
                    : "",
                salesTeamName:
                  leaveTypeObject.salesTeam !== null &&
                    leaveTypeObject.salesTeam.name !== null &&
                    leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                    leaveTypeObject.salesTeam.stockStakeHolderType.prefix !== null
                    ? leaveTypeObject.salesTeam.name +
                    " (" +
                    leaveTypeObject.salesTeam.stockStakeHolderType.prefix +
                    ")"
                    : "",
                salesTeamStockHolderTypeId:
                  leaveTypeObject.salesTeam !== null &&
                    leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                    leaveTypeObject.salesTeam.stockStakeHolderType.id !== null
                    ? leaveTypeObject.salesTeam.stockStakeHolderType.id
                    : "",
                salesTeamStockHolderTypeName:
                  leaveTypeObject.salesTeam !== null &&
                    leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                    leaveTypeObject.salesTeam.stockStakeHolderType.name !== null
                    ? leaveTypeObject.salesTeam.stockStakeHolderType.name
                    : "",
                salesTeamStockHolderTypePrefix:
                  leaveTypeObject.salesTeam !== null &&
                    leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                    leaveTypeObject.salesTeam.stockStakeHolderType.prefix !== null
                    ? leaveTypeObject.salesTeam.stockStakeHolderType.prefix
                    : "",

                leaveTypeId:
                  leaveTypeObject.leaveType !== null &&
                    leaveTypeObject.leaveType.id !== null
                    ? leaveTypeObject.leaveType.id
                    : "",
                leaveTypeName:
                  leaveTypeObject.leaveType !== null &&
                    leaveTypeObject.leaveType.name !== null
                    ? leaveTypeObject.leaveType.name
                    : "",
                authoritySalesPersonId:
                  leaveTypeObject.authoritySalesPersonId === null
                    ? ""
                    : leaveTypeObject.authoritySalesPersonId,

                authoritySalesPersonTypeId:
                  leaveTypeObject.authoritySalesPersonTypeId === null
                    ? ""
                    : leaveTypeObject.authoritySalesPersonTypeId,
                leaveReason:
                  leaveTypeObject.leaveReason === null
                    ? ""
                    : leaveTypeObject.leaveReason,
                fromDate:
                  leaveTypeObject.fromDate === null
                    ? ""
                    : leaveTypeObject.fromDate,
                toDate:
                  leaveTypeObject.toDate === null ? "" : leaveTypeObject.toDate,
                noOfDays:
                  leaveTypeObject.noOfDays === null
                    ? ""
                    : leaveTypeObject.noOfDays,
                description:
                  leaveTypeObject.description === null
                    ? ""
                    : leaveTypeObject.description,
                attachFile:
                  leaveTypeObject.attachFile === null
                    ? ""
                    : leaveTypeObject.attachFile,
                status:
                  leaveTypeObject.status === null ? "" : leaveTypeObject.status,
                isActive:
                  leaveTypeObject.isActive === null
                    ? ""
                    : leaveTypeObject.isActive,
                leaveCancelRemark:
                  leaveTypeObject.leaveCancelRemark === null
                    ? ""
                    : leaveTypeObject.leaveCancelRemark,
                extra1:
                  leaveTypeObject.extra1 === null ? "" : leaveTypeObject.extra1,
                statusForTable:
                  leaveTypeObject.status === null
                    ? ""
                    : leaveTypeObject.status == 0
                      ? "Pending"
                      : leaveTypeObject.status == 1
                        ? "Cancelled"
                        : leaveTypeObject.status == 2
                          ? "Approved"
                          : leaveTypeObject.status == 3
                            ? "Rejected"
                            : "",
              };
              return claimData;
            });

            dispatch(leaveApplySuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });

        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getLeaveForAuthorityPerson = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: leaveApplyURL + "/authority-for-login-person",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((leaveTypeObject, index) => {
          let leaveTypeData = {
            index: index + 1,
            id: leaveTypeObject.id === null ? "" : leaveTypeObject.id,
            salesTeamId:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.id !== null
                ? leaveTypeObject.salesTeam.id
                : "",
            employeeCode:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.employeeCode !== null
                ? leaveTypeObject.salesTeam.employeeCode
                : "",
            salesTeamName:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.name !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType.prefix !== null
                ? leaveTypeObject.salesTeam.name +
                " (" +
                leaveTypeObject.salesTeam.stockStakeHolderType.prefix +
                ")"
                : "",
            authoritySalesPersonName:
              leaveTypeObject.authoritySalesPersonName !== null &&
                leaveTypeObject.authoritySalesPersonTypePrefix !== null
                ? leaveTypeObject.authoritySalesPersonName +
                " (" +
                leaveTypeObject.authoritySalesPersonTypePrefix +
                ")"
                : "",
            salesTeamStockHolderTypeId:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType.id !== null
                ? leaveTypeObject.salesTeam.stockStakeHolderType.id
                : "",
            salesTeamStockHolderTypeName:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType.name !== null
                ? leaveTypeObject.salesTeam.stockStakeHolderType.name
                : "",
            salesTeamStockHolderTypePrefix:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType.prefix !== null
                ? leaveTypeObject.salesTeam.stockStakeHolderType.prefix
                : "",

            leaveTypeId:
              leaveTypeObject.leaveType !== null &&
                leaveTypeObject.leaveType.id !== null
                ? leaveTypeObject.leaveType.id
                : "",
            leaveTypeName:
              leaveTypeObject.leaveType !== null &&
                leaveTypeObject.leaveType.name !== null
                ? leaveTypeObject.leaveType.name
                : "",
            leaveReason:
              leaveTypeObject.leaveReason === null
                ? ""
                : leaveTypeObject.leaveReason,
            authoritySalesPersonId:
              leaveTypeObject.authoritySalesPersonId === null
                ? ""
                : leaveTypeObject.authoritySalesPersonId,

            authoritySalesPersonTypeId:
              leaveTypeObject.authoritySalesPersonTypeId === null
                ? ""
                : leaveTypeObject.authoritySalesPersonTypeId,
            fromDate:
              leaveTypeObject.fromDate === null ? "" : leaveTypeObject.fromDate,
            toDate:
              leaveTypeObject.toDate === null ? "" : leaveTypeObject.toDate,
            noOfDays:
              leaveTypeObject.noOfDays === null ? "" : leaveTypeObject.noOfDays,
            description:
              leaveTypeObject.description === null
                ? ""
                : leaveTypeObject.description,
            attachFile:
              leaveTypeObject.attachFile === null
                ? ""
                : leaveTypeObject.attachFile,
            status:
              leaveTypeObject.status === null ? "" : leaveTypeObject.status,
            isActive:
              leaveTypeObject.isActive === null ? "" : leaveTypeObject.isActive,
            leaveCancelRemark:
              leaveTypeObject.leaveCancelRemark === null
                ? ""
                : leaveTypeObject.leaveCancelRemark,
            extra1:
              leaveTypeObject.extra1 === null ? "" : leaveTypeObject.extra1,
            statusForTable:
              leaveTypeObject.status === null
                ? ""
                : leaveTypeObject.status == 0
                  ? "Pending"
                  : leaveTypeObject.status == 2
                    ? "Approved"
                    : leaveTypeObject.status == 3
                      ? "Rejected"
                      : "Cancelled",
          };
          return leaveTypeData;
        });
        dispatch(leaveForAuthorityPersonSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getLeaveForAuthorityPersonByDates = ({ fromDate, toDate }) => async (dispatch) => {
  try {
    const response = apiGet({
      url: leaveApplyURL + `/authority-for-login-person-date-wise?fromDate=${fromDate}&toDate=${toDate}`,
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((leaveTypeObject, index) => {
          let leaveTypeData = {
            index: index + 1,
            id: leaveTypeObject.id === null ? "" : leaveTypeObject.id,
            salesTeamId:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.id !== null
                ? leaveTypeObject.salesTeam.id
                : "",
            employeeCode:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.employeeCode !== null
                ? leaveTypeObject.salesTeam.employeeCode
                : "",
            salesTeamName:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.name !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType.prefix !== null
                ? leaveTypeObject.salesTeam.name +
                " (" +
                leaveTypeObject.salesTeam.stockStakeHolderType.prefix +
                ")"
                : "",
            authoritySalesPersonName:
              leaveTypeObject.authoritySalesPersonName !== null &&
                leaveTypeObject.authoritySalesPersonTypePrefix !== null
                ? leaveTypeObject.authoritySalesPersonName +
                " (" +
                leaveTypeObject.authoritySalesPersonTypePrefix +
                ")"
                : "",
            salesTeamStockHolderTypeId:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType.id !== null
                ? leaveTypeObject.salesTeam.stockStakeHolderType.id
                : "",
            salesTeamStockHolderTypeName:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType.name !== null
                ? leaveTypeObject.salesTeam.stockStakeHolderType.name
                : "",
            salesTeamStockHolderTypePrefix:
              leaveTypeObject.salesTeam !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType !== null &&
                leaveTypeObject.salesTeam.stockStakeHolderType.prefix !== null
                ? leaveTypeObject.salesTeam.stockStakeHolderType.prefix
                : "",

            leaveTypeId:
              leaveTypeObject.leaveType !== null &&
                leaveTypeObject.leaveType.id !== null
                ? leaveTypeObject.leaveType.id
                : "",
            leaveTypeName:
              leaveTypeObject.leaveType !== null &&
                leaveTypeObject.leaveType.name !== null
                ? leaveTypeObject.leaveType.name
                : "",
            leaveReason:
              leaveTypeObject.leaveReason === null
                ? ""
                : leaveTypeObject.leaveReason,
            authoritySalesPersonId:
              leaveTypeObject.authoritySalesPersonId === null
                ? ""
                : leaveTypeObject.authoritySalesPersonId,

            authoritySalesPersonTypeId:
              leaveTypeObject.authoritySalesPersonTypeId === null
                ? ""
                : leaveTypeObject.authoritySalesPersonTypeId,
            fromDate:
              leaveTypeObject.fromDate === null ? "" : leaveTypeObject.fromDate,
            toDate:
              leaveTypeObject.toDate === null ? "" : leaveTypeObject.toDate,
            noOfDays:
              leaveTypeObject.noOfDays === null ? "" : leaveTypeObject.noOfDays,
            description:
              leaveTypeObject.description === null
                ? ""
                : leaveTypeObject.description,
            attachFile:
              leaveTypeObject.attachFile === null
                ? ""
                : leaveTypeObject.attachFile,
            status:
              leaveTypeObject.status === null ? "" : leaveTypeObject.status,
            isActive:
              leaveTypeObject.isActive === null ? "" : leaveTypeObject.isActive,
            leaveCancelRemark:
              leaveTypeObject.leaveCancelRemark === null
                ? ""
                : leaveTypeObject.leaveCancelRemark,
            extra1:
              leaveTypeObject.extra1 === null ? "" : leaveTypeObject.extra1,
            statusForTable:
              leaveTypeObject.status === null
                ? ""
                : leaveTypeObject.status == 0
                  ? "Pending"
                  : leaveTypeObject.status == 2
                    ? "Approved"
                    : leaveTypeObject.status == 3
                      ? "Rejected"
                      : "Cancelled",
          };
          return leaveTypeData;
        });
        dispatch(leaveForAuthorityPersonSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return { response: [], success: false };
  }
};

export const getLeaveBalaceBySalesTeam =
  ({ salesTeamId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url: leaveApplyURL + "/balance?salesTeamId=" + salesTeamId,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((leaveTypeObject, index) => {
              let leaveTypeData = {
                index: index + 1,
                id:
                  leaveTypeObject.leaveType !== null &&
                    leaveTypeObject.leaveType.id !== null
                    ? leaveTypeObject.leaveType.id
                    : "",
                name:
                  leaveTypeObject.leaveType !== null &&
                    leaveTypeObject.leaveType.name !== null &&
                    leaveTypeObject.balanceLeave !== null
                    ? leaveTypeObject.leaveType.name +
                    " (Balance Leave : " +
                    leaveTypeObject.balanceLeave +
                    ")"
                    : "",
                appliedLeave:
                  leaveTypeObject.appliedLeave === null
                    ? ""
                    : leaveTypeObject.appliedLeave,
                approvedLeave:
                  leaveTypeObject.approvedLeave !== null
                    ? leaveTypeObject.approvedLeave
                    : "",
                balanceLeave:
                  leaveTypeObject.balanceLeave !== null
                    ? leaveTypeObject.balanceLeave
                    : "",
                totalLeave:
                  leaveTypeObject.totalLeave !== null
                    ? leaveTypeObject.totalLeave
                    : "",
                leaveTypeId:
                  leaveTypeObject.leaveType !== null &&
                    leaveTypeObject.leaveType.id !== null
                    ? leaveTypeObject.leaveType.id
                    : "",
                leaveTypeName:
                  leaveTypeObject.leaveType !== null &&
                    leaveTypeObject.leaveType.name !== null
                    ? leaveTypeObject.leaveType.name
                    : "",
              };
              return leaveTypeData;
            });
            dispatch(leaveBalanceBySalesTeamSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getLeaveSummaryBySalesTeam =
  ({ salesTeamId, fromDate, toDate }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            leaveApplyURL +
            "/list-by-sales-team-and-date?salesTeamId=" +
            salesTeamId +
            "&fromDate=" +
            fromDate +
            "&toDate=" +
            toDate,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((leaveTypeObjectNew, index) => {
              let leaveTypeData = {
                index: index + 1,
                id: leaveTypeObjectNew.id === null ? "" : leaveTypeObjectNew.id,
                employeeCode:
                  leaveTypeObjectNew.employeeCode !== null
                    ? leaveTypeObjectNew.employeeCode
                    : "",
                name:
                  leaveTypeObjectNew.salesTeamName !== null &&
                    leaveTypeObjectNew.stockStakeHolderTypePrefix !== null
                    ? leaveTypeObjectNew.salesTeamName +
                    " (" +
                    leaveTypeObjectNew.stockStakeHolderTypePrefix +
                    ")"
                    : "",
                authoritySalesPersonName:
                  leaveTypeObjectNew.authoritySalesPersonName !== null &&
                    leaveTypeObjectNew.authoritySalesPersonTypePrefix !== null
                    ? leaveTypeObjectNew.authoritySalesPersonName +
                    " (" +
                    leaveTypeObjectNew.authoritySalesPersonTypePrefix +
                    ")"
                    : "",
                fromDate:
                  leaveTypeObjectNew.fromDate !== null
                    ? leaveTypeObjectNew.fromDate
                    : "",

                toDate:
                  leaveTypeObjectNew.toDate !== null
                    ? leaveTypeObjectNew.toDate
                    : "",

                noOfDays:
                  leaveTypeObjectNew.noOfDays !== null
                    ? leaveTypeObjectNew.noOfDays
                    : "",
                days:
                  leaveTypeObjectNew.days !== null ? leaveTypeObjectNew.days : "",

                leaveTypeName:
                  leaveTypeObjectNew.leaveTypeName !== null
                    ? leaveTypeObjectNew.leaveTypeName
                    : "",

                leaveReason:
                  leaveTypeObjectNew.leaveReason !== null
                    ? leaveTypeObjectNew.leaveReason
                    : "",

                description:
                  leaveTypeObjectNew.description !== null
                    ? leaveTypeObjectNew.description
                    : "",

                status:
                  leaveTypeObjectNew.status === null
                    ? ""
                    : leaveTypeObjectNew.status == 0
                      ? "Pending"
                      : leaveTypeObjectNew.status == 1
                        ? "Cancelled"
                        : leaveTypeObjectNew.status == 2
                          ? "Approved"
                          : "Reject",
                salesTeamId:
                  leaveTypeObjectNew.salesTeamId === null
                    ? ""
                    : leaveTypeObjectNew.salesTeamId,
                leaveTypeId:
                  leaveTypeObjectNew.leaveTypeId !== null
                    ? leaveTypeObjectNew.leaveTypeId
                    : "",

                userName:
                  leaveTypeObjectNew.userName !== null
                    ? leaveTypeObjectNew.userName
                    : "",
                stockStakeHolderTypeName:
                  leaveTypeObjectNew.stockStakeHolderTypeName !== null
                    ? leaveTypeObjectNew.stockStakeHolderTypeName
                    : "",
                stockStakeHolderTypePrefix:
                  leaveTypeObjectNew.stockStakeHolderTypePrefix !== null
                    ? leaveTypeObjectNew.stockStakeHolderTypePrefix
                    : "",

                authoritySalesPersonTypeName:
                  leaveTypeObjectNew.authoritySalesPersonTypeName !== null
                    ? leaveTypeObjectNew.authoritySalesPersonTypeName
                    : "",

                attachFile:
                  leaveTypeObjectNew.attachFile !== null
                    ? leaveTypeObjectNew.attachFile
                    : "",
              };
              return leaveTypeData;
            });
            dispatch(leaveSummaryBySalesTeamSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return { response: [], success: false };
      }
    };


export const getLeaveSummaryForSalesTeam =
  ({ salesTeamId, fromDate, toDate }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            leaveApplyURL +
            "/list-by-sales-team-and-date?salesTeamId=" +
            salesTeamId +
            "&fromDate=" +
            fromDate +
            "&toDate=" +
            toDate,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((leaveTypeObjectNew, index) => {
              let leaveTypeData = {
                index: index + 1,
                id: leaveTypeObjectNew.id === null ? "" : leaveTypeObjectNew.id,
                employeeCode:
                  leaveTypeObjectNew.employeeCode !== null
                    ? leaveTypeObjectNew.employeeCode
                    : "",
                salesTeamName:
                  leaveTypeObjectNew.salesTeamName !== null &&
                    leaveTypeObjectNew.stockStakeHolderTypePrefix !== null
                    ? leaveTypeObjectNew.salesTeamName +
                    " (" +
                    leaveTypeObjectNew.stockStakeHolderTypePrefix +
                    ")"
                    : "",
                authoritySalesPersonName:
                  leaveTypeObjectNew.authoritySalesPersonName !== null &&
                    leaveTypeObjectNew.authoritySalesPersonTypePrefix !== null
                    ? leaveTypeObjectNew.authoritySalesPersonName +
                    " (" +
                    leaveTypeObjectNew.authoritySalesPersonTypePrefix +
                    ")"
                    : "",
                fromDate:
                  leaveTypeObjectNew.fromDate !== null
                    ? leaveTypeObjectNew.fromDate
                    : "",

                toDate:
                  leaveTypeObjectNew.toDate !== null
                    ? leaveTypeObjectNew.toDate
                    : "",

                noOfDays:
                  leaveTypeObjectNew.noOfDays !== null
                    ? leaveTypeObjectNew.noOfDays
                    : "",
                days:
                  leaveTypeObjectNew.days !== null ? leaveTypeObjectNew.days : "",

                leaveTypeName:
                  leaveTypeObjectNew.leaveTypeName !== null
                    ? leaveTypeObjectNew.leaveTypeName
                    : "",

                leaveReason:
                  leaveTypeObjectNew.leaveReason !== null
                    ? leaveTypeObjectNew.leaveReason
                    : "",

                description:
                  leaveTypeObjectNew.description !== null
                    ? leaveTypeObjectNew.description
                    : "",
                statusFlag:
                  leaveTypeObjectNew.status === null
                    ? ""
                    : leaveTypeObjectNew.status,
                status:
                  leaveTypeObjectNew.status === null
                    ? ""
                    : leaveTypeObjectNew.status == 0
                      ? "Pending"
                      : leaveTypeObjectNew.status == 1
                        ? "Cancelled"
                        : leaveTypeObjectNew.status == 2
                          ? "Approved"
                          : "Rejected",
                salesTeamId:
                  leaveTypeObjectNew.salesTeamId === null
                    ? ""
                    : leaveTypeObjectNew.salesTeamId,
                leaveTypeId:
                  leaveTypeObjectNew.leaveTypeId !== null
                    ? leaveTypeObjectNew.leaveTypeId
                    : "",

                userName:
                  leaveTypeObjectNew.userName !== null
                    ? leaveTypeObjectNew.userName
                    : "",
                stockStakeHolderTypeName:
                  leaveTypeObjectNew.stockStakeHolderTypeName !== null
                    ? leaveTypeObjectNew.stockStakeHolderTypeName
                    : "",
                stockStakeHolderTypePrefix:
                  leaveTypeObjectNew.stockStakeHolderTypePrefix !== null
                    ? leaveTypeObjectNew.stockStakeHolderTypePrefix
                    : "",

                authoritySalesPersonTypeName:
                  leaveTypeObjectNew.authoritySalesPersonTypeName !== null
                    ? leaveTypeObjectNew.authoritySalesPersonTypeName
                    : "",

                attachFile:
                  leaveTypeObjectNew.attachFile !== null
                    ? leaveTypeObjectNew.attachFile
                    : "",
              };
              return leaveTypeData;
            });
            dispatch(leaveSummaryBySalesTeamSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return { response: [], success: false };
      }
    };
// http://localhost:8088/api/distribution/v1/leave-apply/get-under-sales-team-leaves?salesTeamId=6d6d698a-8710-4493-b267-c4622cc2d8c1&fromDate=10-08-2025&toDate=30-08-2025&flag=1
export const getLeaveAnalysisDataBySalesTeam =
  ({ salesTeamId, fromDate, toDate, flag }) =>
    async () => {
      try {
        const response = apiGet({
          url:
            leaveApplyURL +
            "/get-under-sales-team-leaves?salesTeamId=" +
            salesTeamId +
            "&fromDate=" +
            fromDate +
            "&toDate=" +
            toDate +
            "&flag=" +
            flag,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((leaveTypeObjectNew, index) => {
              let leaveTypeData = {
                index: index + 1,
                id: leaveTypeObjectNew.id === null ? "" : leaveTypeObjectNew.id,
                employeeCode:
                  leaveTypeObjectNew.employeeCode !== null
                    ? leaveTypeObjectNew.employeeCode
                    : "",
                name:
                  leaveTypeObjectNew.salesTeamName !== null &&
                    leaveTypeObjectNew.stockStakeHolderTypePrefix !== null
                    ? leaveTypeObjectNew.salesTeamName
                    : "",
                salesTeamTypeName:
                  leaveTypeObjectNew.stockStakeHolderTypeName !== null
                    ? leaveTypeObjectNew.stockStakeHolderTypeName
                    : "",
                authoritySalesPersonName:
                  leaveTypeObjectNew.authoritySalesPersonName !== null &&
                    leaveTypeObjectNew.authoritySalesPersonTypePrefix !== null
                    ? leaveTypeObjectNew.authoritySalesPersonName +
                    " (" +
                    leaveTypeObjectNew.authoritySalesPersonTypePrefix +
                    ")"
                    : "",
                startDate:
                  leaveTypeObjectNew.fromDate !== null
                    ? leaveTypeObjectNew.fromDate
                    : "",

                endDate:
                  leaveTypeObjectNew.toDate !== null
                    ? leaveTypeObjectNew.toDate
                    : "",

                noOfDays:
                  leaveTypeObjectNew.noOfDays !== null
                    ? leaveTypeObjectNew.noOfDays
                    : "",
                days:
                  leaveTypeObjectNew.days !== null ? leaveTypeObjectNew.days : "",

                leaveTypeName:
                  leaveTypeObjectNew.leaveTypeName !== null
                    ? leaveTypeObjectNew.leaveTypeName
                    : "",

                leaveReason:
                  leaveTypeObjectNew.leaveReason !== null
                    ? leaveTypeObjectNew.leaveReason
                    : "",

                description:
                  leaveTypeObjectNew.description !== null
                    ? leaveTypeObjectNew.description
                    : "",

                status:
                  leaveTypeObjectNew.status === null
                    ? ""
                    : leaveTypeObjectNew.status == 0
                      ? "Pending"
                      : leaveTypeObjectNew.status == 1
                        ? "Cancelled"
                        : leaveTypeObjectNew.status == 2
                          ? "Approved"
                          : "Reject",
                flag:
                  leaveTypeObjectNew.status === null
                    ? ""
                    : leaveTypeObjectNew.status,
                salesTeamId:
                  leaveTypeObjectNew.salesTeamId === null
                    ? ""
                    : leaveTypeObjectNew.salesTeamId,
                leaveTypeId:
                  leaveTypeObjectNew.leaveTypeId !== null
                    ? leaveTypeObjectNew.leaveTypeId
                    : "",

                userName:
                  leaveTypeObjectNew.userName !== null
                    ? leaveTypeObjectNew.userName
                    : "",
                stockStakeHolderTypeName:
                  leaveTypeObjectNew.stockStakeHolderTypeName !== null
                    ? leaveTypeObjectNew.stockStakeHolderTypeName
                    : "",
                stockStakeHolderTypePrefix:
                  leaveTypeObjectNew.stockStakeHolderTypePrefix !== null
                    ? leaveTypeObjectNew.stockStakeHolderTypePrefix
                    : "",

                authoritySalesPersonTypeName:
                  leaveTypeObjectNew.authoritySalesPersonTypeName !== null
                    ? leaveTypeObjectNew.authoritySalesPersonTypeName
                    : "",

                attachFile:
                  leaveTypeObjectNew.attachFile !== null
                    ? leaveTypeObjectNew.attachFile
                    : "",
              };
              return leaveTypeData;
            });
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return { response: [], success: false };
      }
    };


export const getLeaveBalanceInfoOfSalesTeam =
  ({ salesTeamId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            leaveApplyURL + "/leave-balance-info-by-sales-team?salesTeamId=" + salesTeamId
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data;
            let leaveTypeData = {
              id: row.id === null ? "" : row.id,
              employeeCode:
                row.employeeCode !== null
                  ? row.employeeCode
                  : "",
              salesTeamName:
                row.name !== null &&
                  row.stockStakeHolderTypePrefix !== null
                  ? row.name +
                  " (" +
                  row.stockStakeHolderTypePrefix +
                  ")"
                  : "",
              authoritySalesPersonId:
                row.reportingManagerTypeId !== null
                  ? row.reportingManagerTypeId
                  : "",
              authoritySalesPersonUserTypeId:
                row.reportingManagerTypeId !== null
                  ? row.reportingManagerTypeId
                  : "",
              authoritySalesPersonName:
                row.reportingManagerName !== null &&
                  row.reportingManagerTypePrefix !== null
                  ? row.reportingManagerName +
                  " (" +
                  row.reportingManagerTypePrefix +
                  ")"
                  : "",
              leaveBalanceList: row.leaveBalanceList !== null ?
                row.leaveBalanceList.map((datObj, index) => {
                  let detailsObj = {
                    index: index + 1,
                    id: datObj.leaveType !== null && datObj.leaveType.id !== null ? datObj.leaveType.id : "",
                    leaveTypeId:
                      datObj.leaveType !== null && datObj.leaveType.id !== null ? datObj.leaveType.id : "",
                    leaveTypeName:
                      datObj.leaveType !== null && datObj.leaveType.name !== null ? datObj.leaveType.name : "",
                    name:
                      datObj.leaveType !== null && datObj.leaveType.name !== null ? datObj.leaveType.name : "",
                    openingLeave:
                      datObj.openingLeave !== null ? datObj.openingLeave : "",
                    earnedLeave:
                      datObj.earnedLeave !== null ? datObj.earnedLeave : "",
                    approvedLeave:
                      datObj.approvedLeave !== null ? datObj.approvedLeave : "",
                    appliedLeave:
                      datObj.appliedLeave !== null ? datObj.appliedLeave : "",
                    encashLeave:
                      datObj.encashLeave !== null ? datObj.encashLeave : "",
                    balanceLeave:
                      datObj.balanceLeave !== null ? datObj.balanceLeave : "",
                    totalLeave:
                      datObj.totalLeave !== null ? datObj.totalLeave : "",
                  }
                  return detailsObj;
                }) : [],
            };
            dispatch(leaveBalanceInfoSuccess({ row: leaveTypeData }));
            return { response: leaveTypeData, success };
          }
          return { response: {}, success };
        });
        return response;
      } catch (e) {
        return { response: {}, success: false };
      }
    };
